export const UI_TEXT_GET_A_PLUS_LOAD = `Get a Plus Load`
